import styled from '@emotion/styled';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  // Hauteur réellement visible (barres du navigateur et zones de l'iPhone déduites), 100vh en repli.
  minHeight: ['100vh', '100dvh'],
  width: '100vw',
  maxWidth: '100vw',
});
